import React from 'react';

interface ShowHideOptionsLinkProps {
  showingAll: boolean;
  styles?: string;
  onClick: () => void;
}

const ShowHideOptionsLink = ({
  showingAll,
  styles = '',
  onClick,
}: ShowHideOptionsLinkProps) => {
  const caption = showingAll ? 'See fewer topics' : 'See more topics';
  const symbol = showingAll ? '⌃' : '⌄';
  const symbolClass = showingAll ? 'top-[12px]' : 'top-[4px]';

  const handleClick = (event) => {
    event.preventDefault();
    onClick();
  };

  return (
    <a
      href="#"
      className={`cursor-pointer py-[8px] px-[16px] rounded-[50px] font-size-[14px] font-normal leading-[22.4px] relative text-gray-800 visited:text-gray-800 ${styles}`}
      onClick={handleClick}
      role="button"
    >
      {caption}
      <span className={`absolute ml-[9px] ${symbolClass}`}>{symbol}</span>
    </a>
  );
};
export default ShowHideOptionsLink;
